import { createAuthClient } from "better-auth/react";

/**
 * El cliente de sesión.
 *
 * Sin `baseURL`: el frontend y la API comparten origen gracias al proxy de
 * Vite, así que las llamadas salen relativas (`/api/auth/...`). Poner una URL
 * absoluta las volvería cross-site y traería de vuelta el problema de la
 * cookie que el ERP ya documentó en packages/auth.
 */
export const authClient = createAuthClient();
